import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useFeatures } from "../context/FeaturesContext";

/** Sends people home when a page belongs to a switched-off feature.
 *
 * Settings → Features turns features on and off. A page that is off is
 * also gone from the menus, so this only catches old bookmarks and links.
 */
export default function FeatureGate({ flag, children }: { flag: string; children: ReactNode }) {
  const { isEnabled, isLoaded } = useFeatures();
  if (isLoaded && !isEnabled(flag)) return <Navigate to="/home" replace />;
  return <>{children}</>;
}
